import type { ISpread } from "../../spreadsSlice";

export const periodicForecastSpread: ISpread = {
  id: "spread_periodic_forecast",
  name: "Периодический прогноз",
  altNames: ["Time Period Spread"],
  purpose:
    "Осознание ключевых тем и энергий выбранного периода, подготовка к изменениям и наблюдение за развитием жизненного цикла.",
  cardsCount: 12,
  layout: `       [12]
  [11]       [1]
[10]           [2]
 [9]           [3]
 [8]           [4]
   [7]       [5]
       [6]`,
  positions: [
    {
      id: "period_1",
      title: "Период 1",
      meaning: "Первый месяц или этап выбранного цикла.",
    },
    {
      id: "period_2",
      title: "Период 2",
      meaning: "Второй месяц или этап выбранного цикла.",
    },
    {
      id: "period_3",
      title: "Период 3",
      meaning: "Третий месяц или этап выбранного цикла.",
    },
    {
      id: "period_4",
      title: "Период 4",
      meaning: "Четвёртый месяц или этап выбранного цикла.",
    },
    {
      id: "period_5",
      title: "Период 5",
      meaning: "Пятый месяц или этап выбранного цикла.",
    },
    {
      id: "period_6",
      title: "Период 6",
      meaning: "Шестой месяц или этап выбранного цикла.",
    },
    {
      id: "period_7",
      title: "Период 7",
      meaning: "Седьмой месяц или этап выбранного цикла.",
    },
    {
      id: "period_8",
      title: "Период 8",
      meaning: "Восьмой месяц или этап выбранного цикла.",
    },
    {
      id: "period_9",
      title: "Период 9",
      meaning: "Девятый месяц или этап выбранного цикла.",
    },
    {
      id: "period_10",
      title: "Период 10",
      meaning: "Десятый месяц или этап выбранного цикла.",
    },
    {
      id: "period_11",
      title: "Период 11",
      meaning: "Одиннадцатый месяц или этап выбранного цикла.",
    },
    {
      id: "period_12",
      title: "Период 12",
      meaning: "Двенадцатый месяц или этап выбранного цикла.",
    },
  ],
  symbolism:
    "Круг символизирует цикличность времени, а каждая карта представляет отдельную фазу или этап общего процесса.",
  archetypes: ["Цикл времени", "Фазы", "Последовательность"],
  psychology:
    "Помогает воспринимать жизнь как смену этапов, принимать перемены и более осознанно распределять внимание в течение длительного периода.",
  procedure: {
    preparation:
      "Определить период, который будет исследоваться, например следующий год.",
    steps:
      "Перетасовать колоду с фокусом на выбранном периоде; выложить двенадцать карт последовательно по месяцам или этапам; прочитать каждую карту отдельно и затем рассмотреть повторяющиеся темы всего цикла.",
  },
  interpretations: [
    "Каждая карта описывает основную тему соответствующего месяца или этапа.",
    "Повторяющиеся мотивы помогают увидеть общий характер выбранного периода.",
  ],
  nuances: [
    "Не воспринимать прогноз как фиксированную судьбу.",
    "Важно анализировать повторяющиеся мотивы и связи между соседними этапами.",
    "SOURCE также описывает вариант из шести карт, где каждая карта соответствует двум месяцам; этот вариант пока отдельно не реализован.",
  ],
  examples: [],
  selfQuestions: [
    "Как я могу подготовиться к предстоящим переменам?",
    "Какие темы будут особенно важны?",
    "Как использовать этот цикл для роста?",
  ],
};

